import { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from './index.module.css';

const IMAGE_CDN = "https://api.asicentral.com/v1/";

function buildImageUrl(rawPath, size) {
  if (!rawPath) return "";
  const path = rawPath.replace(/^\/+/, "");
  if (/^https?:\/\//.test(path)) {
    const [url] = path.split(/\?size=/);
    return `${url}?size=${size}`;
  }
  const base = IMAGE_CDN.replace(/\/+$/, "");
  return `${base}/${path}?size=${size}`;
}

const ImageSlider = ({ productImage, mainImage,  useImageCDN = true }) => {
    const [Image, setImage] = useState(null);

    useEffect(() => {
        if (productImage?.length > 0) {
            setImage(productImage[0]);
        } else if (mainImage) {
            setImage(mainImage);
        }
    }, []);

      const imageSrc = useImageCDN
        ? `${IMAGE_CDN}/${Image}?size=normal`
        : Image;

    return (
        <Box className={styles.sliderRoot}>
            <Box className={styles.primaryImageContainer}>
                <img
                    src={buildImageUrl(Image, "large")}
                    alt={"product_view"}
                    className={styles.primaryImage}
                />
            </Box>
        </Box>
    );
};

export default ImageSlider;
